import styles from "./LinkButton.module.css";

export const LinkButton = ({ href, children }: { href: string; children: string }) => (
  <a
    className={styles.linkButton}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    title={children}
  >
    {children}
  </a>
);
